import { forwardRef, type SVGProps } from 'react'

interface TransferUserIconProps extends SVGProps<SVGSVGElement> {}

export const TransferUserIcon = forwardRef<
  SVGSVGElement,
  TransferUserIconProps
>((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M240-120 80-280l160-160 56 56-64 64h496l-64-64 56-56 160 160-160 160-56-56 64-64H232l64 64-56 56ZM80-520v-23q0-24 13-44t36-30q26-11 53.5-17t57.5-6q30 0 57.5 6t53.5 17q23 10 36 30t13 44v23H80Zm480 0v-23q0-24 13-44t36-30q26-11 53.5-17t57.5-6q30 0 57.5 6t53.5 17q23 10 36 30t13 44v23H560ZM240-680q-33 0-56.5-23.5T160-760q0-33 23.5-56.5T240-840q33 0 56.5 23.5T320-760q0 33-23.5 56.5T240-680Zm480 0q-33 0-56.5-23.5T640-760q0-33 23.5-56.5T720-840q33 0 56.5 23.5T800-760q0 33-23.5 56.5T720-680Z" />
    </svg>
  )
})

TransferUserIcon.displayName = 'TransferUserIcon'
